import { AlertTriangle } from "lucide-react";

// Banner amarillo grande arriba de la pantalla.
// Uso principal: modo prueba activo.
export function ModoPruebaBanner() {
  return (
    <div className="flex w-full items-center justify-center gap-3 bg-yellow-400 px-4 py-3 text-center font-bold text-black">
      <AlertTriangle className="h-5 w-5 shrink-0" />
      <span>MODO PRUEBA — Las jugadas NO se están registrando</span>
    </div>
  );
}
